<template>
  <app-layout>
    <fiscal-data-table :title="$t('Módulo Fiscal')"></fiscal-data-table>
  </app-layout>
</template>
<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import FiscalDataTable from '../components/FiscalDataTable';
export default {
  components: {
    AppLayout,
    FiscalDataTable,
  },
};
</script>
